export const CLAUDE_CODE_INVOCATION_NAMES = {
  AI_FLOW_GRAPH_GENERATION: 'claude-code.ai-flow-graph-generation',
  AUTHENTICATION_LOGIN_GUIDE_FROM_HAR:
    'claude-code.authentication-login-guide-from-har',
  CANDIDATE_PROBE_CODE_ANALYSIS: 'claude-code.candidate-probe-code-analysis',
  CODE_GRAPH_QUESTION_ANSWERING: 'claude-code.code-graph-question-answering',
  DEEP_SECURITY_TEST_CASE_SCAN: 'claude-code.deep-security-test-case-scan',
  ENDPOINTS_DISCOVERY_FROM_CODE: 'claude-code.endpoints-discovery-from-code',
  EVALUATION: 'claude-code.evaluation',
  FULL_CODE_QUESTION_ANSWERING: 'claude-code.full-code-question-answering',
  GRAPH_GENERATION: 'claude-code.graph-generation',
  GRAPH_REGENERATION: 'claude-code.graph-regeneration',
  REMEDIATION: 'claude-code.remediation',
  REPOSITORY_ANALYSIS: 'claude-code.repository-analysis',
  REPOSITORY_SCOPING: 'claude-code.repository-scoping',
  REPOSITORY_PROFILING: 'claude-code.repository-profiling',
  SECURITY_TEST_CASE: 'claude-code.security-test-case',
  SECURITY_TEST_CASE_CHANGE_BASED:
    'claude-code.security-test-case-change-based',
  SECURITY_TEST_CASE_COMBINED: 'claude-code.security-test-case-combined',
  SECURITY_TEST_CASE_COMBINED_CODEX:
    'claude-code.security-test-case-combined-codex',
  SECURITY_TEST_CASE_CVE: 'claude-code.security-test-case-cve',
  SECURITY_TEST_CASE_GATEKEEPER: 'claude-code.security-test-case-gatekeeper',
  SIGNAL_VALIDATION: 'claude-code.signal-validation',
  SMALL_FAST: 'claude-code.small-fast',
  SUB_ENTRY_POINT_ENHANCEMENT: 'claude-code.sub-entry-point-enhancement',
} as const;

export const CLAUDE_CODE_TASK_INVOCATION_NAMES = {
  AI_FRAMEWORK_DETECTOR: 'claude-code.task.ai-framework-detector',
  AI_GRAPH_BUILDER: 'claude-code.task.ai-graph-builder',
  APP_WIDE_CLASSIFIER: 'claude-code.task.app-wide-classifier',
  CVE_SIGNAL_VALIDATOR: 'claude-code.task.cve-signal-validator',
  ENDPOINT_PAYLOAD_CRAFTER: 'claude-code.task.endpoint-payload-crafter',
  ENDPOINT_SCANNER: 'claude-code.task.endpoint-scanner',
  GUARDRAILS_VALIDATOR: 'claude-code.task.guardrails-validator',
  PR_REVIEW: 'claude-code.task.pr-review',
} as const;

export type ClaudeCodeInvocationName =
  (typeof CLAUDE_CODE_INVOCATION_NAMES)[keyof typeof CLAUDE_CODE_INVOCATION_NAMES];

export type ClaudeCodeTaskInvocationName =
  (typeof CLAUDE_CODE_TASK_INVOCATION_NAMES)[keyof typeof CLAUDE_CODE_TASK_INVOCATION_NAMES];

export const CLAUDE_CODE_INVOCATION_NAME_VALUES = Object.values(
  CLAUDE_CODE_INVOCATION_NAMES,
) as [ClaudeCodeInvocationName, ...ClaudeCodeInvocationName[]];
